var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAlternative(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28125 16.7108L16.063 3.92901L23.4903 11.3563L10.7085 24.138L3.28125 16.7108Z",
    fill: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1428 16.2804C13.1938 18.3313 13.1938 21.6566 11.1428 23.7076C9.09185 25.7586 5.76656 25.7586 3.71558 23.7076C1.6646 21.6566 1.6646 18.3313 3.71558 16.2804C5.76655 14.2294 9.09185 14.2294 11.1428 16.2804Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4905 3.92932C25.5415 5.9803 25.5415 9.30559 23.4905 11.3566C21.4395 13.4075 18.1142 13.4075 16.0632 11.3566C14.0123 9.30559 14.0123 5.9803 16.0632 3.92932C18.1142 1.87834 21.4395 1.87834 23.4905 3.92932Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAlternative);
export default __webpack_public_path__ + "static/media/logo-alternative.077c0a8f.svg";
export { ForwardRef as ReactComponent };